export const AUDIT_STATISTICS_EXPORT_REQUEST = 'AUDIT_STATISTICS_EXPORT_REQUEST';
export const AUDIT_STATISTICS_EXPORT_SUCCESS = 'AUDIT_STATISTICS_EXPORT_SUCCESS';
export const AUDIT_STATISTICS_EXPORT_FAILURE = 'AUDIT_STATISTICS_EXPORT_FAILURE';
